import { useState, useEffect } from "react";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

export default function RevenueDetailsGraph() {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  // Update window width on resize
  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const data = {
    labels: ["Jan", "Feb", "Mar", "Apr", "May", "June"],
    datasets: [
      {
        label: "Monthly",
        data: [300, 200, 200, 250, 150, 150],
        backgroundColor: "#F05203",
        stack: "combined",
        borderRadius: 20,
        barThickness: windowWidth < 600 ? 30 : windowWidth < 900 ? 40 : 50,
      },
      {
        label: "Weekly",
        data: [0, 50, 0, 100, 0, 0],
        backgroundColor: "#82BD00",
        stack: "combined",
        borderRadius: 20,
        barThickness: windowWidth < 600 ? 30 : windowWidth < 900 ? 40 : 50,
      },
      {
        label: "Daily",
        data: [150, 100, 300, 100, 400, 400],
        backgroundColor: "#EBEBEB",
        stack: "combined",
        borderRadius: 20,
        barThickness: windowWidth < 600 ? 30 : windowWidth < 900 ? 40 : 50,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      tooltip: {
        mode: "index",
        intersect: false,
        callbacks: {
          label: function (context) {
            return `${context.dataset.label}: ${context.parsed.y} $`;
          },
        },
        titleFont: { size: windowWidth < 600 ? 12 : 14 },
        bodyFont: { size: windowWidth < 600 ? 10 : 12 },
      },
      legend: {
        display: false,
      },
    },
    scales: {
      x: {
        stacked: true,
        ticks: {
          padding: 5,
          font: {
            size: windowWidth < 600 ? 10 : 12,
          },
        },
        grid: {
          display: true,
          drawOnChartArea: false,
        },
      },
      y: {
        stacked: true,
        beginAtZero: true,
        max: 800,
        ticks: {
          stepSize: 200,
          callback: function (value) {
            return "$ " + value ;
          },
          font: {
            size: windowWidth < 600 ? 10 : 12,
          },
        },
        grid: {
          drawTicks: false,
        },
      },
    },
    categoryPercentage: 0.8, // Controls the width of the bar group relative to the category
  barPercentage: 0.9,
  };

  return (
    <article className="hours-spent-card">
      <div className="bar-holder">
        <Bar data={data} options={options} />
      </div>
    </article>
  );
}